import React from 'react';
import './apexoCommon.css';

export interface StaticNotificationAction {
  label: string;
  action: () => void;
}

export interface StaticNotification {
  id: string;
  title: string;
  body: string;
  icon: React.ReactNode;
  iconBgColor?: string;
  actions: StaticNotificationAction[];
}

interface StaticNotificationsFlyoutProps {
  open: boolean;
  onClose: () => void;
  notifications: StaticNotification[];
  onAllowBrowserOptions?: () => void; // equivalent to the kIsWeb logic
}

export default function StaticNotificationsFlyout({ 
  open, 
  onClose, 
  notifications,
  onAllowBrowserOptions 
}: StaticNotificationsFlyoutProps) {
  if (!open) return null;

  return (
    <>
      <div className="apexo-flyout-backdrop" onClick={onClose} />
      <div className="apexo-flyout-panel">
        <div className="apexo-flyout-body">
          {notifications.length === 0 ? (
            <div className="apexo-no-items">
              <span className="apexo-no-items-icon">📭</span>
              <p>No new notifications</p>
            </div>
          ) : (
            notifications.map((notif, index) => {
              const isLast = index === notifications.length - 1;
              return (
                <div key={notif.id} className={`apexo-notif-item ${isLast ? 'no-border' : ''}`}>
                  <div className="apexo-notif-main">
                    <div 
                      className="apexo-notif-icon-box"
                      style={{ backgroundColor: notif.iconBgColor || '#64748b' }}
                    >
                      {notif.icon}
                    </div>
                    <div className="apexo-notif-content">
                      <div className="apexo-notif-title">{notif.title}</div>
                      <div className="apexo-notif-body">{notif.body}</div>
                    </div>
                  </div>
                  {notif.actions.length > 0 && (
                    <div className="apexo-notif-actions">
                      {notif.actions.map((act, i) => (
                        <button 
                          key={i} 
                          className="apexo-hyperlink-btn"
                          onClick={() => { act.action(); onClose(); }}
                        >
                          {act.label}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              );
            })
          )}
          
          {onAllowBrowserOptions && (
            <>
              <div className="apexo-divider" />
              <button 
                className="apexo-hyperlink-btn w-full-center" 
                onClick={() => { onAllowBrowserOptions(); onClose(); }}
              >
                🔔 Enable Notifications
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
}
